import {
  FETCH_EXPENSES_SUCCESS,
  SHOW_EXPENSES_LOADER,
  SHOW_EXPENSES_MESSAGE,
  HIDE_EXPENSES_MESSAGE,
  SAVE_EXPENSES_SUCCESS,
  CHANGE_STATE_NEW_EXPENSES
} from 'constants/ActionTypes';

const INIT_STATE = {
  loader: true,
  alertMessage: '',
  showMessage: false,
  isErrorMessage: false,
  expensesData: [],
  pages: -1,
  page: 0,
  pageSize: 20,
  totalEuro: 0,
  totalRsd: 0,
  pastEvaluatedKey: undefined,
  lastEvaluatedKey: undefined,
  newExpensesAdded: false,
};


export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case FETCH_EXPENSES_SUCCESS: {
      return {
        ...state,
        expensesData: action.payload.rows,
        loader: false,
        newExpensesAdded: false,
        pages: Math.ceil(action.payload.count / state.pageSize),
        totalEuro: action.payload.total.euro,
        totalRsd: action.payload.total.rsd,
        page: action.payload.page,
        pastEvaluatedKey: (state.lastEvaluatedKey && action.payload.page !== 0) ? state.pastEvaluatedKey : action.payload.LastEvaluatedKey,
        lastEvaluatedKey: action.payload.LastEvaluatedKey
      }
    }
    case SHOW_EXPENSES_LOADER: {
      return {
        ...state,
        page: action.payload ? Number(action.payload.page) : 0,
        loader: true
      }
    }
    case SHOW_EXPENSES_MESSAGE: {
      return {
        ...state,
        alertMessage: action.payload.message,
        isErrorMessage: action.payload.messageStatus,
        showMessage: true,
        loader: false
      }
    }
    case HIDE_EXPENSES_MESSAGE: {
      return {
        ...state,
        alertMessage: '',
        isErrorMessage: false,
        showMessage: false,
        loader: false
      }
    }
    case SAVE_EXPENSES_SUCCESS: {
      return {
        ...state,
        newExpensesAdded: true
      }
    }
    case CHANGE_STATE_NEW_EXPENSES: {
      return {
        ...state,
        newExpensesAdded: false
      }
    }
    
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./reducers/Expenses.js